var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "inline-block",
      verticalAlign: "middle"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 17.1523H10.4992C9.59289 17.1536 8.69028 17.0328 7.81438 16.7929L7.62513 16.7411L7.45114 16.8318C6.82617 17.1577 5.37093 17.7976 2.91855 18.2441C3.31076 17.2177 3.65093 15.9331 3.76176 14.741L3.78308 14.5116L3.62255 14.3463C2.23221 12.9151 1.3999 11.053 1.3999 9.02609C1.3999 4.58708 5.42279 0.899902 10.4999 0.899902C15.577 0.899902 19.5999 4.58708 19.5999 9.02609C19.5999 13.4651 15.577 17.1523 10.4999 17.1523Z",
    fill: "#7741DE",
    stroke: "#7741DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/chat_bubble.457fd4e2.svg";
export { ForwardRef as ReactComponent };